module.exports = __webpack_public_path__ + "static/media/nonord-c-11.d39a4f54.mp3";